import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Breadcrumbs } from '@ff-it/ui';
import { useRealUser } from 'services';
import { Icon } from './Icon';
import { Impersonation } from './Impersontation';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { GlobalSearch } from './GlobalSearch';
import { EnterpriseSwitcher } from './EnterpriseSwitcher';

export function TopNav(): ReactElement {
  const { email } = useRealUser();

  return (
    <nav className="navbar navbar-light bg-light border-bottom navbar-expand p-0" id="top-nav">
      <div className="mr-auto d-flex align-items-center">
        <EnterpriseSwitcher />
        <Breadcrumbs className="mb-0" />
      </div>
      <GlobalSearch />
      <Impersonation />
      <ul className="navbar-nav ml-2">
        <li className="nav-item">
          <EnterpriseLink to="/profile" className="nav-link">
            <Icon icon="user" /> {email}
          </EnterpriseLink>
        </li>
        <li className="nav-item">
          <NavLink to="/logout" className="nav-link">
            <Icon icon="right-from-bracket" /> Sign out
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
